import { render, staticRenderFns } from "./NovaCategoria.vue?vue&type=template&id=6b56f89e"
import script from "./NovaCategoria.vue?vue&type=script&lang=js"
export * from "./NovaCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports